@if (missingDocuments.length) {
  <div class="missing-docs-block">
    <div class="missing-docs-block__header">
      <i class="fa fa-exclamation-circle"></i>
      {{ 'DOCUMENTS.requests.missing_documents' | translate }}
    </div>
    @for (document of missingDocuments; track document) {
      <div class="missing-docs-block__item">
        <span class="missing-docs-block__code">{{ document.docType.trim() }}</span>
        – {{ ('DOCUMENTS.requests.document_types.' + document.docType.trim()) | translate }}
      </div>
    }
    @if (trimmedComment) {
      <div class="missing-docs-block__item missing-docs-block__comment">{{ trimmedComment }}</div>
    }
  </div>
}
